import { PageData } from "@/model/Pagenation";

/**
 * 페이지네이션 req
 */
export class PageReq {
    page: number;
    size: number;
    searchText?: string;
    sort?: string;
}

/**
 * 페이지네이션 res
 */
export class PageRes<T extends Record<string, any>> extends PageData {
    content: T[];
}
